// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"298":"1613adf6","408":"2faba8e4"}[chunkId] + ".js";
};